import { AnimatePresence, Label, Paragraph, ThemeableStack } from 'tamagui'

interface FieldProps extends React.ComponentProps<typeof ThemeableStack> {
  errors: any[]
  label?: React.ReactNode
  suffix?: React.ReactNode
}

export function FormField({ errors = [], label, suffix, children, ...props }: FieldProps) {
  const safeErrors = Array.isArray(errors) ? errors : errors ? [errors] : []
  const hasError = safeErrors.length > 0
  return (
    <ThemeableStack theme={hasError ? 'red' : null} gap="$1" {...props}>
      {label && <Label size="$3" theme="alt2" lineHeight="$1" pl="$2" children={label} />}
      {children}
      {suffix}
      <FieldError errors={safeErrors} />
    </ThemeableStack>
  )
}

export function FieldError({ errors }: { errors: FieldProps['errors'] }) {
  const safeErrors = Array.isArray(errors) ? errors : errors ? [errors] : []
  const error = safeErrors
    .flatMap((e) => (typeof e === 'object' && e !== null ? e.message : e))
    .filter(Boolean)
    .join(', ')
  return (
    <AnimatePresence>
      {!!error && (
        <Paragraph
          key={error}
          theme="alt2"
          fos="$1"
          lh="$1"
          ml="$2"
          animation="200ms"
          enterStyle={{
            y: -4,
            o: 0,
          }}
          exitStyle={{
            y: -4,
            o: 0,
          }}
          fontWeight="500"
        >
          {error}
        </Paragraph>
      )}
    </AnimatePresence>
  )
}
